import * as React from 'react'
import { Text, StyleSheet, Pressable, PressableProps } from 'react-native'
import {
  FontAwesomeIcon,
  IconName,
  IconPrefix,
  findIconDefinition,
} from '@purposity/icons'
import * as Colors from '@themes/Colors'

type Props = {
  label: string
  iconName: IconName
  iconPrefix?: IconPrefix
  size?: number
  color?: string
  bgColor?: string
  hideBorder?: boolean
} & PressableProps

export function CircleButton(props: Props) {
  const {
    label,
    iconName,
    iconPrefix = 'fal',
    size = 32,
    color = Colors.originalBlack,
    bgColor = Colors.white,
    hideBorder = false,
    ...restProps
  } = props
  const borderWidth = hideBorder ? 0 : 1
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={label}
      style={({ hovered, pressed }) => [
        styles.circle,
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          fontSize: size,
          backgroundColor: bgColor,
          borderColor: color,
          borderWidth,
        },
        hovered && { backgroundColor: Colors.altWhite },
        pressed && { backgroundColor: Colors.neutralGray },
      ]}
      {...restProps}
    >
      {/* <Text style={{ width: size / 2, height: size / 2 }}> */}
      <FontAwesomeIcon
        style={{
          pointerEvents: 'none',
        }}
        icon={findIconDefinition({ prefix: iconPrefix, iconName })}
        color={color}
      />
      {/* </Text> */}
    </Pressable>
  )
}

const styles = StyleSheet.create({
  circle: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.originalBlack,
    borderWidth: 1,
    borderColor: Colors.originalBlack,
    opacity: 1,
  },
})
